var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fit absolute-center bg-primary text-white text-bold text-h6"},[_vm._v("\n  Autenticado com sucesso no Zoho CRM!\n")])}
var staticRenderFns = []

export { render, staticRenderFns }